import { Grid2, Tooltip } from "@mui/material";
import React from "react";
import styles from "./OrgNameStyle.module.scss";

function OrganizationName(props) {
  const { image, name, owner } = props;
  return (
    <Grid2 className={styles.nameContainer}>
      <Grid2 className={styles.imgContainer}>{image}</Grid2>
      <Grid2 className={styles.orgNameContainer}>
        <Grid2 className={styles.orgName}>
          <Tooltip title={name} arrow="down">
            <span>{name}</span>
          </Tooltip>
        </Grid2>
        <Grid2 className={styles.orgEmail}>{owner}</Grid2>
      </Grid2>
    </Grid2>
  );
}

export default OrganizationName;
